export * from "./types";
export * from "./memory/index";
export * from "./audio";

// Agent modules (selective exports to avoid duplicate type conflicts)
export {
	estimateTokens,
	getInputCredits,
	getOutputCredits,
	getTotalCredits,
	INPUT_TOKENS_PER_CREDIT,
	OUTPUT_TOKENS_PER_CREDIT,
	MODEL_PRICING,
	getModelPricing,
	getModelMultiplier,
	CREDIT_VALUE_USD,
	calculateImageCredits,
	getImageModelPricing,
	IMAGE_MODEL_PRICING,
	getCanonicalImageModel,
	calculateInputCredits,
	calculateOutputCredits,
	calculateTotalCredits,
	AUDIO_MODEL_PRICING,
	calculateTranscriptionCredits,
	calculateTTSCredits,
	getAudioModelPricing,
	COMPACTION_SOFT_RATIO,
	COMPACTION_HARD_RATIO,
	COMPACTION_EMERGENCY_RATIO,
	COMPACTION_MODEL,
	buildCompactionPrompt,
	triggerCompaction,
	triggerCompactionAsync,
	prepareConversationWindows,
	estimateConversationTokens,
	getConversationBucket,
	DEFAULT_CONVERSATION_WINDOW_CONFIG,
	getModel,
	getVLMModel,
	createDynamicModel,
	getModelProvider,
	setAIUserContext,
	clearAIUserContext,
	getAIUserContext,
	routeModelCall,
	checkCloudAIAvailability,
	getRecommendedMode,
	extractJsonFromMarkdown,
} from "./agent";

export type {
	ModelType,
	CompactionLevel,
	CompactionPlatform,
	CompactionResult,
	CompactionOptions,
	CompactionResponse,
	ConversationWindowMessage,
	ConversationWindowConfig,
	ConversationWindowBucket,
	ConversationWindowResult,
	TokenizedConversationWindowMessage,
	ConversationWindowBucketStats,
	ConversationWindowRole,
	AIUserContext,
	UserType,
	ModelCallOptions,
	ModelCallResult,
} from "./agent";
